(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/thunks/pay.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/thunks/pay.js');
"use strict";


const makePayment = svs.gamePackage.pay.makePayment;
const updateBalance = svs.gamePackage.redux.accountSlice.actions.updateBalance;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const pay = () => dispatch => {
  if (isSelfService) {
    const _svs$gamePackage$redu = svs.gamePackage.redux.store.getState().gamePackage,
      sizes = _svs$gamePackage$redu.sizes,
      activeIndex = _svs$gamePackage$redu.activeIndex;
    svs.gamePackage.selfservice.addToCart({
      productFlag: svs.gamePackage.data.packageConfig.title.toLowerCase(),
      wagers: svs.gamePackage.data.packageConfig.selfserviceIds[activeIndex],
      cost: sizes[activeIndex].price
    });
  } else {
    makePayment({
      onSuccess: _ref => {
        let balance = _ref.newBalance;
        dispatch(updateBalance({
          balance
        }));
      }
    });
  }
};
svs.gamePackage.redux.thunks.pay = pay;

 })(window);